module.exports = __webpack_public_path__ + "img/WeChat.f6a0103e.svg";